import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function featuredEventsSlider() {
  const sliderContainer = $(".section-events .swiper");
  if (!sliderContainer.length) return;
  const slider = initializeSwiper();
  //
}

function initializeSwiper() {
  const swiper = new Swiper(".section-events .swiper", {
    // configure Swiper to use modules
    modules: [Navigation, Pagination],
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
    },
    slidesPerView: 1.2,
    spaceBetween: 20,
    // breakpoints: {
    //   640: {
    //     slidesPerView: 2,
    //     spaceBetween: 20,
    //   },
    //   768: {
    //     slidesPerView: 4,
    //     spaceBetween: 40,
    //   },
    // },
  });
  return swiper;
}
